export const getInitialRecipients = users =>
  users
    .filter(user => !user.disabled)
    .map(user => ({
      id: user.id,
      value: `${user.firstName} ${user.lastName}`,
      type: 'user',
      email: user.email,
      editable: true
    }));

const getRecipient = recipient => {
  const { user, addressbookContact, email } = recipient;
  if (user) {
    return {
      id: user.id,
      value: `${user.firstName} ${user.lastName}`,
      type: 'user',
      recipientId: recipient.id,
      email: user.email
    };
  }

  if (addressbookContact) {
    return {
      id: addressbookContact.id,
      value: `${addressbookContact.firstName} ${addressbookContact.lastName}`,
      type: 'addressbookContact',
      recipientId: recipient.id,
      email: addressbookContact.email
    };
  }

  if (email) {
    return {
      value: email,
      type: 'email',
      recipientId: recipient.id
    };
  }

  return {};
};

export const getSavedInitialRecipients = recipients =>
  recipients.map(recipient => ({
    ...getRecipient(recipient),
    editable: true
  }));

export const getTransformedRecipients = recipientFormItems =>
  recipientFormItems
    .map(formItem => {
      const { recipientId, type, id, value } = formItem;
      if (type === 'user') {
        return recipientId ? { id: recipientId, userId: id } : { userId: id };
      }

      if (type === 'addressbookContact') {
        return recipientId ?
          { id: recipientId, addressbookContactId: id } :
          { addressbookContactId: id };
      }

      return recipientId ?
        { id: recipientId, email: value } :
        { email: value };
    });
